// src/components/Bookkausneuvo/Bookkausneuvo.jsx
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  Search,
  Send,
  Star,
  CheckCircle2,
  Music,
  MailCheck,
  ArrowBigDown,
} from "lucide-react";

export default function BookingFlow() {
  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: "ease-out",
      offset: 100,
      once: false,
      mirror: true,
      anchorPlacement: "top-bottom",
    });
  }, []);

  const steps = [
    { icon: Search,       title: "Etsi & valitse esiintyjä", text: "Tutustu esiintyjän profiiliin." },
    { icon: CheckCircle2, title: "Valitse päivä",            text: "Keikkakalenterista näet vapaat päivät reaaliajassa." },
    { icon: Music,        title: "Täytä lomake",             text: "Valitse esiintymisen kesto ja lisää tapahtumapaikka." },
    { icon: Send,         title: "Tarjous heti",             text: "Selkeä kokonaishinta ilman piilokuluja." },
    { icon: MailCheck,    title: "Buukkaus",                 text: "Hyväksy tarjous tai vapauta päivä muille." },
    { icon: Star,         title: "Arvioi esiintyjä",         text: "Palaute vaikuttaa esiintyjän yleisarvosanaan." },
  ];

  const Card = ({ title, text, align }) => (
    <div
      className={[
        "max-w-[30rem] rounded-xl border border-white/10",
        "bg-white/40 dark:bg-electric/15 px-3 py-3 md:px-4 md:py-3 shadow-sm",
        align === "left" ? "ml-auto mr-4 md:mr-6" : "mr-auto ml-4 md:ml-6",
      ].join(" ")}
    >
      <div className="font-customFont2 dark:text-white/90 text-black/90 text-base sm:text-lg font-semibold text-center mb-1">
        {title}
      </div>
      <p className="dark:text-white/80 text-black/80 font-customFont1 text-sm sm:text-[15px] leading-snug text-center">
        {text}
      </p>
    </div>
  );

  return (
    <section className="relative max-w-5xl mx-auto">
      <h3 className="font-customFont2 text-3xl text-black/80 dark:text-white/80 sm:text-4xl lg:text-5xl text-center py-4">
        Näin palvelu toimii:
      </h3>

      {/* Keskijana – hieman lyhyempi */}
      <div
        aria-hidden
        className="pointer-events-none absolute left-1/2 top-16 bottom-16 -translate-x-1/2 w-px bg-black/15 dark:bg-white/10"
      />

      <ol className="space-y-8 md:space-y-10">
        {steps.map((s, i) => {
          const Icon = s.icon;
          const left = i % 2 === 0;

          return (
            <li
              key={s.title}
              className="relative grid grid-cols-1 md:grid-cols-[1fr_64px_1fr] items-center gap-y-3"
            >
              {/* Vasen sarake (md+, vain parillisilla riveillä) */}
              <div className="hidden md:block md:order-1">
                {left && (
                  <div data-aos="fade-right" data-aos-once="false">
                    <Card title={s.title} text={s.text} align="left" />
                  </div>
                )}
              </div>

              {/* Ikoni */}
              <div className="order-1 md:order-2 relative flex items-center justify-center z-10">
                <div
                  className="grid place-items-center w-10 h-10 rounded-full
                             bg-white/15 dark:bg-white/10
                             border border-black/10 dark:border-white/20
                             backdrop-blur"
                >
                  <Icon className="w-5 h-5 text-black/80 dark:text-primary" />
                </div>
              </div>

              {/* Oikea sarake / mobiilikortti */}
              <div className={`order-2 md:order-3 ${left ? "md:hidden" : ""}`}>
                {!left ? (
                  <div data-aos="fade-left" data-aos-once="false">
                    <Card title={s.title} text={s.text} align="right" />
                  </div>
                ) : (
                  <div
                    className="md:hidden"
                    data-aos="fade-right"
                    data-aos-once="false"
                  >
                    <Card title={s.title} text={s.text} align="left" />
                  </div>
                )}
              </div>
            </li>
          );
        })}
      </ol>

      {/* Mobiilinuoli – hieman pienempi ja lähempänä */}
      <div className="sm:hidden flex justify-center mt-5" aria-hidden="true">
        <ArrowBigDown className="w-8 h-8 animate-bounce dark:text-white/80 text-black/80 opacity-80" />
      </div>
    </section>
  );
}
